export const formatUserDisplayName = (user) =>
  `${user?.surname || ""} ${user?.name || ""} ${user?.patronymic || ""}`.trim();

export const compareUsersAlphabetically = (a, b) => {
  const surnameCompare = (a?.surname || "").localeCompare(
    b?.surname || "",
    "ru",
    { sensitivity: "base" },
  );
  if (surnameCompare !== 0) return surnameCompare;

  const nameCompare = (a?.name || "").localeCompare(b?.name || "", "ru", {
    sensitivity: "base",
  });
  if (nameCompare !== 0) return nameCompare;

  return (a?.patronymic || "").localeCompare(b?.patronymic || "", "ru", {
    sensitivity: "base",
  });
};

export const sortUsersAlphabetically = (users = []) =>
  [...users].sort(compareUsersAlphabetically);

export const mapUsersToSelectOptions = (users = []) =>
  sortUsersAlphabetically(users).map((user) => ({
    value: user.id,
    label: formatUserDisplayName(user) || user.username || `#${user.id}`,
  }));
